import { Network } from '@yme/services/network';
export const getOffersPromoPages = async (currentPath, limit, offset) => {
    const response = await Network.get('/services/api/search/filtering', {
        params: {
            data: `{"pagePath": "${currentPath}"}`,
            type: 'offersPromo',
            limit,
            offset,
        },
    });
    return response;
};
